import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { Section } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import AddOrEditPeriodModal from 'modules/work_schedules/components/AddOrEditPeriodModal'
import type { RouteContextParams } from 'modules/work_schedules/lib/RouteContextParams'
import { PeriodScheduleType } from 'modules/work_schedules/lib/forms/PeriodScheduleTypeForm'
import OverlapPeriod, { ScheduleType } from 'modules/work_schedules/store/models/OverlapPeriod'

const AddPeriodPage = () => {
  const { navigation } = useNavigation()

  const { id, schedule_id } = useStrictParams<'id' | 'schedule_id'>()
  const { workSchedule, overlapPeriods } = useOutletContext<RouteContextParams>()
  const defaultPeriod = workSchedule
    ? overlapPeriods.getDefaultPeriod(workSchedule?.attributes.id)
    : undefined

  const scheduleType = defaultPeriod
    ? defaultPeriod.attributes.schedule_type
    : PeriodScheduleType.flexible

  const currentYear = moment().year()
  const startDate = `${currentYear}-01-01`
  const endDate = `${currentYear}-12-31`

  const period = new OverlapPeriod({
    id: +id,
    schedule_id: +schedule_id,
    default: false,
    start_date: startDate,
    end_date: endDate,
    schedule_type: scheduleType as ScheduleType,
  })

  const navigate = useNavigate()

  const workScheduleRoute = navigation.settings.workSchedule.id.fullPath({ id })

  const onClose = () => {
    navigate(workScheduleRoute)
  }

  const onSuccess = () => {
    navigate(workScheduleRoute)
  }

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <ResponsivePage.Body showHeader={false} variant="wide" loading={loading} error={null}>
      <Section.TwoThirds
        illustration="calendar-clock"
        title={i18n.t('settings.work_schedule.period_section.add_period_modal.title')}
        description={i18n.t('settings.work_schedule.period_section.add_period_modal.description')}
      >
        <AddOrEditPeriodModal
          onClose={onClose}
          onSuccess={onSuccess}
          id={Number(id)}
          period={period}
          add
          contractVersions={contractVersions}
        />
      </Section.TwoThirds>
    </ResponsivePage.Body>
  )
}

export default AddPeriodPage
